exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".campusIdManage .el-select[data-v-45e94dc3]{display:inline-block}.campusIdManage .el-input[data-v-45e94dc3]{display:inline-block;width:auto}.campusIdManage .el-button[data-v-45e94dc3]{display:inline-block}.campusIdManage .el-button+.el-button[data-v-45e94dc3]{margin-left:0}.search[data-v-45e94dc3]{margin-left:30px;margin-bottom:20px}.el-dialog__body p[data-v-45e94dc3]{line-height:38px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-45e94dc3&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/userM/campusIdManage.vue
// module id = 512
// module chunks = 0